import { ToastProgrammatic as Toast } from 'buefy';
import moment from 'moment';
import store from '@/store/store';
import { sendMail } from '@/api/mail/index';
import { v4 as uuidv4 } from 'uuid';
import { db } from '@/plugins/firebase';

const getStackTrace = () => {
  const obj = {};
  Error.captureStackTrace(obj, getStackTrace);
  return obj.stack;
};

let environnement = '';
if (process.env.NODE_ENV === 'production') {
  if (process.env.AFFIXE2_ENV === 'staging') {
    environnement = 'Dev';
  } else {
    environnement = 'Prod';
  }
} else {
  environnement = 'Dev';
}

export function sendToFirebase(message, e) {
  const id = uuidv4();
  const objectErreur = {
    date: new Date(),
    urlApplication: window.location.href,
    site: store.getters['user/site'],
    identifiantUtilisateur: store.getters['user/userEmail'],
    message,
    urlRequette: e.config ? e.config.url : 'aucune url',
    methodeRequette: e.config ? e.config.method : 'aucune requete',
    traceErreur: getStackTrace(),
    erreurMessage: e.message,
    erreurStack: e.stack,
    vue: false,
    corrige: false,
    environnement,
    id,
  };
  db.ref(`errorFodect/${id}`).update(objectErreur);
  return objectErreur;
}

export async function sendMailError(message, e) {
  const objectErreur = sendToFirebase(message, e);
  let traceErreur = '';
  let erreurStack = '';
  objectErreur.traceErreur.split('\n').forEach(ligne => { traceErreur += `<li><code>${ligne}</code></li>`; });
  objectErreur.erreurStack.split('\n').forEach(ligne => { erreurStack += `<li><code>${ligne}</code></li>`; });
  const mail = {
    From: `${objectErreur.identifiantUtilisateur}`,
    FromName: 'Support Erreur Fodect',
    To: [
      'support@quadra-diffusion.fr',
      'mouhayad.hounkanrin-ayinla@quadra-ao.sn',
      'carolle.bonou@quadra-ao.sn',
    ],
    Cc: [],
    Cci: [],
    Objet: `Alert Erreur Fodect: ${objectErreur.message}`,
    Corps: `<h1 style="text-align: center">Information liées à l'erreur:</h1>
            <ul>
              <li> Logiciel: <code>Fodect</code> </li>
              <li> Site: <code>${objectErreur.site}</code> </li>
              <li> Identifiant utilisateur: <code>${objectErreur.identifiantUtilisateur}</code> </li>
              <li> Url application: <code>${objectErreur.urlApplication}</code> </li>
              <li> Message d'erreur: <code>${objectErreur.message}</code> </li>
              <li> Trace de la pile d'erreur: <ul>${traceErreur}</ul> </li>
              <li> Message Objet Erreur: <code>${objectErreur.erreurMessage}</code> </li>
              <li> Trace de la pile Objet Erreur: <ul>${erreurStack}</ul> </li>
              <li> Date de l'erreur: <code>${moment(objectErreur.date).format('DD/MM/YYYY HH:mm:ss')}</code> </li>
              <li> Url de la reque d'erreur: <code>${objectErreur.urlRequette}</code> </li>
              <li> Methode de la reque d'erreur: <code>${objectErreur.methodeRequette}</code> </li>
              <li> Id Firebase de l'erreur: <code>${objectErreur.id}</code> </li>
              <li> Environnement: <code>${objectErreur.environnement}</code> </li>
            </ul>`,
  };
  const data = new FormData();
  data.append('mailRequest', JSON.stringify(mail));
  try {
    await sendMail(data, 'mail');
    Toast.open({
      duration: 5000,
      message: 'Le support est informé de l\'erreur',
      position: 'is-top',
      type: 'is-success',
    });
  } catch (error) {
    sendToFirebase('Erreur lors de l\'envoi du mail d\'erreur', e);
  }
}

export default function gestionErreur(message/* , e */) {
  Toast.open({
    duration: 5000,
    message: message,
    position: 'is-top',
    type: 'is-danger',
  });
  // if (process.env.NODE_ENV === 'production' && process.env.AFFIXE2_ENV !== 'staging') {
  //   sendMailError(message, e);
  // }
  // A décommenter si besoin de tester l'envoi des erreurs en dev
  // sendMailError(message, e);
}



// WEBPACK FOOTER //
// ./src/services/general/gestionErreur.js